module.exports = __webpack_public_path__ + "img/success.ef120c51.png";